import { Brandfolder as BF, Organization as Org } from '@brandfolder/types';
import { MessageDescriptor } from '@lingui/core';

export interface Brandfolder extends BF {
  key: string;
}

export interface Organization extends Org {
  key: string;
}

export enum PeoplePageParamKeys {
  AssetIds = 'ids',
  Filter = 'filter',
  Search = 'search',
  Sort = 'sort',
  Page = 'page',
}

export enum PersonDetailsParamKeys {
  Tag = 'tag',
  Sort = 'sort',
  Page = 'page',
}

export enum FilterValues {
  All = 'all',
  Tagged = 'tagged',
  Untagged = 'untagged',
}

export enum SortValues {
  Newest = 'upload-date-ascending',
  Oldest = 'upload-date-descending',
  Least = 'frequency-least',
  Most = 'frequency-most',
  Ascending = 'name-ascending',
  Descending = 'name-descending',
}

export interface EmptyStateContent {
  [key: string]: {
    heading: MessageDescriptor;
    imgSrc: string;
    subheading: MessageDescriptor;
  };
}

export type PeoplePageQueryState = {
  [key in PeoplePageParamKeys]?: FilterValues | SortValues | string;
};

export type PersonDetailsQueryState = {
  [key in PersonDetailsParamKeys]?: SortValues | string;
};

export type PeoplePageQueryDispatch = (nextState: PeoplePageQueryState) => void;

export type PersonDetailsQueryDispatch = (nextState: PersonDetailsQueryState) => void;

/*  eslint-disable @typescript-eslint/naming-convention */
export interface PeoplePageRequestParams {
  asset_id?: string[];
  page_num?: number;
  per_page_count?: number;
  sort_by?: SortValues;
  status?: FilterValues;
}

export interface PeoplePage {
  face_id: string;
  face_label: string;
  gcs_path: string;
}

export interface PersonDetailsRequestParams {
  face_id?: string;
  org_key?: string;
  bf_key?: string;
  page_num?: number;
  per_page_count?: number;
  sort_by?: SortValues;
}

export interface PersonDetails {
  asset_id: string;
  attachment_id: string;
  gcs_path: string;
  match_face_id: string;
}

export interface PaginationResponse {
  current_page: number;
  next_page: number;
  prev_page: number;
  total_count: number;
  total_pages: number;
}
/*  eslint-enable @typescript-eslint/naming-convention */

export interface PersonDetailsResponse {
  data: PersonDetails[];
  meta: PaginationResponse;
}

export interface PeoplePageResponse {
  data: PeoplePage[];
  meta: PaginationResponse;
}

export interface PeoplePageFetchState {
  initialLoadingState: boolean;
  peopleData: PeoplePageResponse;
  peopleDataError: boolean;
  peopleDataLoading: boolean;
}

export interface PersonDetailsFetchState {
  personDetailsData: PersonDetailsResponse;
  personDetailsError: boolean;
  personDetailsLoading: boolean;
}
